var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Graphs/Policy Graph/Expandible Sign/Expand") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Graphs/Policy-Graph/Expandible-Sign/Expand",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#F1F4FB",
    fill: "#FFFFFF",
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#2E3955",
    fillRule: "nonzero",
    points: "7.10436742 12.4471061 7.10436742 8.75110606 3.66970076 8.75110606 3.66970076 7.08977273 7.10436742 7.08977273 7.10436742 3.39377273 8.93370076 3.39377273 8.93370076 7.08977273 12.3683674 7.08977273 12.3683674 8.75110606 8.93370076 8.75110606 8.93370076 12.4471061"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/Expand.91592318445201daa002cc989515a876.svg";
export { ForwardRef as ReactComponent };